import { render, staticRenderFns } from "./consequence.vue?vue&type=template&id=2584e73c&scoped=true"
import script from "./consequence.vue?vue&type=script&lang=js"
export * from "./consequence.vue?vue&type=script&lang=js"
import style0 from "./consequence.vue?vue&type=style&index=0&id=2584e73c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2584e73c",
  null
  
)

export default component.exports